export default {
  loading: 'Loading...',
  authenticating: 'Authenticating...',
  saving: 'Saving...',
  loggingOut: 'Logging out...',
  passwordReset: 'Requesting Password Reset...',
  setPassword: 'Setting password...',
  searching: 'Getting Results...',
  gettingHotel: 'Getting hotel details...',
  preparingBooking: 'Preparing booking...',
  submittingBooking: 'Submitting booking...',
  redirecting: 'Redirecting...',
  gettingProposal: 'Getting proposal...',
  gettingBooking: 'Getting booking...',
  requesting: 'Requesting...',
  loadingUsers: 'Loading users...',
  gettingAccommodationProducts: 'Loading available accommodations...',
  addingLodging: 'Loading new lodging data...',
};
